import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

import { COLOR_ACCENT, COLOR_BLACK, COLOR_STROKE_SECONDARY, COLOR_WH } from '../colors';
import { BORDER_RADIUS_M } from '../common';
import { FontFamilies, FontWeights } from '../Typography';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getMuiTooltipOverrides = (theme: Theme): ComponentsOverrides['MuiTooltip'] => ({
  tooltip: {
    borderRadius: BORDER_RADIUS_M,
    background: COLOR_ACCENT,
    fontWeight: FontWeights.SemiBold,
    fontFamily: FontFamilies.primary,
    fontSize: '20px',
    lineHeight: '32px',
    maxWidth: 'unset',
    padding: theme.spacing(0.5, 1.5),
    color: COLOR_BLACK,
    whiteSpace: 'nowrap',
    wordWrap: 'unset',
    arrow: {
      background: COLOR_ACCENT,
    },

    '&.secondary': {
      background: COLOR_STROKE_SECONDARY,
      fontSize: '14px',
      lineHeight: '28px',
      padding: theme.spacing(0.5, 1),
      fontWeight: FontWeights.Regular,
      color: COLOR_WH,
    },

    [theme.breakpoints.down('md')]: {
      fontSize: 15,
      lineHeight: '20px',
    },
  },
  arrow: {
    '&::before': {
      color: COLOR_ACCENT,
      borderRadius: '4px',
    },

    '&.secondary': {
      '&::before': {
        color: COLOR_STROKE_SECONDARY,
        borderRadius: '1px',
      },
    },
  },
});

export const getMuiTooltipDefaultProps = (): ComponentsProps['MuiTooltip'] => ({
  arrow: true,
});
